import { render, staticRenderFns } from "./OrganizationRoles.vue?vue&type=template&id=085d6746"
import script from "./OrganizationRoles.vue?vue&type=script&lang=js"
export * from "./OrganizationRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports